import {
  Component, OnInit, Input, SimpleChanges, OnChanges
  , ChangeDetectorRef
} from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

@Component({
  selector: 'app-highchart',
  templateUrl: './highchart.component.html',
  styleUrls: ['./highchart.component.scss']
})


export class HighchartComponent implements OnInit
  , OnChanges {
  @Input() chartOptions
  highcharts = Highcharts;

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ''
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Check if chartData has changed
    if (changes['chartOptions']) {
      this.cdr.detectChanges();
    }
  }
  addComponentRef(chart: any) {
    chart.parentComponent = this;
  }

}
